import './HomePage.css';
import {
  HeroSection,
  ReelSection,
  ProjectsScroller,
  ViewAllWorkSection,
  AboutSection,
  ClientsSection,
  ContactSection,
} from '../../components/sections';

const HomePage = () => {
  return (
    <main id="top" className="home-page" data-testid="home-page">
      <HeroSection />
      <ReelSection />
      <ProjectsScroller />
      <ViewAllWorkSection />
      <AboutSection />
      <ClientsSection />
      <ContactSection />
    </main>
  );
};

export default HomePage;
